<template lang="pug">
v-container.justify-center.mt-6.mt-md-10.mb-5.page-product
  .py-10.d-flex.justify-center(v-if="!product.title")
    v-progress-circular(size="50", color="primary", indeterminate)
  template(v-else)
    custom-title(simple, style="border-color: var(--v-primary-base)") {{ product.title }}
    .d-flex.align-center.mb-4
      v-btn(icon, small)
        v-icon(small) fas fa-shopping-cart
      v-icon.px-3(x-small) fas fa-chevron-right
      v-breadcrumbs.pa-0.font-weight-bold(:items="breadcrumbs")
        template(#divider)
          v-icon(x-small) fas fa-chevron-right
    grid-container(cols="auto", cols-md="max-content auto")
      product-gallery-widget(
        :items="product.img.list",
        :main="product.img.featured.path"
      )
      div
        .ck-content(v-html="product.text")
        v-card.d-flex.justify-center(
          :href="getWhatsappLinkFromPhone(staffMember.tel)",
          target="_blank",
          width="max-content",
          flat
        )
          v-sheet.pa-5.rounded-0.d-flex.align-center(color="#25d366")
            v-icon(color="white", large) fab fa-whatsapp
          .secondary.rounded-0.white--text.py-1.px-4
            .text-h6.text-md-h5.font-weight-bold Solicite um orçamento
            .text-h6 {{ staffMember.tel }}
            span {{ staffMember.name }}
</template>

<script>
import CustomTitle from "../../others/CustomTitle.vue";
import ProductGalleryWidget from "../../widgets/ProductGallery.vue";
import { getWhatsappLinkFromPhone } from "../../utils.js";

export default {
  data: () => ({
    product: {},
  }),
  computed: {
    productId() {
      return this.$route.params.product.replace(/^.*-([0-9]+)$/, "$1");
    },
    staffMember() {
      return this.$rest("staff").getters.getById(2);
    },
    breadcrumbs() {
      const { brand, category, subcategory, subsubcategory } = this.product;

      const r = [];

      if (!brand || !brand.id) return r;
      r.push({
        text: brand.title,
        disabled: false,
        to: "/produtos?b=" + brand.id,
      });

      if (!category || !category.id) return r;
      r.push({
        text: category.title,
        disabled: false,
        to: `/produtos?c=${category.id}`,
      });

      if (!subcategory) return r;
      r.push({
        text: subcategory.title,
        disabled: false,
        to: `/produtos?sc=${subcategory.id}`,
      });

      if (!subsubcategory || !subsubcategory.id) return r;
      r.push({
        text: subsubcategory.title,
        disabled: false,
        to: `/produtos?ssc=${subsubcategory.id}`,
      });

      return r;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(date)
      );
    },
    getWhatsappLinkFromPhone,
  },
  watch: {
    productId(v) {
      this.$rest("products").get({ id: v });
    },
  },
  beforeCreate() {
    this.$rest("staff").get();
  },
  created() {
    this.product = {};

    this.$rest("products")
      .get({ id: this.productId })
      .then((data) => (this.product = data))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },

  components: {
    CustomTitle,
    ProductGalleryWidget,
  },
};
</script>

<style>
.page-product .v-breadcrumbs__item {
  color: var(--v-secondary-darken4);
}
</style>
